
    import Vue from "vue";
    import {Component} from "vue-property-decorator";
    import {VueInject} from "@/VueIntegration/VueInjectable";
    import {DagNode} from "@/Core/Dag";
    import {Slideshow, SlideshowEvents} from "@/slideshow";
    import {PubSub} from "@/Core/PubSub";

    @Component({})
    export default class ProgressIndicator extends Vue {
        
        @VueInject("Slideshow")
        slideshow: Slideshow;

        @VueInject("PubSub")
        pubSub: PubSub;

        path: NavigationNode[] = [];
        currentPoint: NavigationNode|null = null;

        isBarDisplayed = true;

        get percentComplete() {
            let fullLength = 0;
            let completeLength = 0;

            for (let i = 0; i < this.path.length; i++) {
                let node = this.path[i];
                if (node.subNodes.length > 0) {
                    for (let j = 0; j < node.subNodes.length; j++) {
                        let subNode = node.subNodes[j];
                        fullLength += 1;
                        if (subNode.visited)
                            completeLength += 1;
                    }
                }
                else {
                    fullLength += 1;
                    if (node.visited)
                        completeLength += 1;
                }
            }

            return Math.round(((completeLength - 1) / Math.max(fullLength - 1, 1)) * 100);
        }

        created() {
            this.pubSub.subscribeToEvent(SlideshowEvents.Resize, () => {
                this.isBarDisplayed = this.canDisplayFullProgressBar();
            });
        }

        mounted() {
            this.calculatePath();
            this.pubSub.subscribeToEvent(SlideshowEvents.SlideEntered, () => {
                this.calculatePath();
            });

            this.$nextTick(() => this.isBarDisplayed = this.canDisplayFullProgressBar());
        }

        canDisplayFullProgressBar() {
            let container = <HTMLElement> this.$refs['container'];
            let ballWidth = 40;
            return container.clientHeight > 25 && this.path.length * ballWidth < container.clientWidth;
        }

        calculatePath() {
            let navPoints: NavigationNode[] = [];
            let currentNode: DagNode<string>|null = this.slideshow.slidesGraph.root;
            let travellerBranchIndex = 0;
            let inBranch = 0;
            let visited = true;
            this.slideshow.slidesGraph.updateMaxLengths();
            let currentGroupId = null;

            while (currentNode != null) {
                inBranch -= Math.max(0, currentNode.getConnectionsTo() - 1);
                let slideData = this.slideshow.getSlideMetadata(currentNode.value);

                if (slideData.groupId != null && slideData.groupId !== currentGroupId) {
                    currentGroupId = slideData.groupId;
                    navPoints.push({node: currentNode, visited: visited, subNodes: []});
                }
                else {
                    currentGroupId = null;
                    navPoints.push({node: currentNode, subNodes: [], visited: visited});
                }

                if (slideData.groupId != null) {
                    navPoints[navPoints.length - 1].subNodes.push({node: currentNode, visited: visited});
                }

                if (this.slideshow.slideTraveller.currentNode === currentNode) {
                    visited = false;
                    this.currentPoint = navPoints[navPoints.length - 1];
                }

                if (currentNode.numberOfConnections() > 1) {
                    inBranch += currentNode.edges.length - 1;

                    if (travellerBranchIndex < this.slideshow.slideTraveller.branchesTaken.length) {
                        let branchIndex = this.slideshow.slideTraveller.branchesTaken[travellerBranchIndex];
                        currentNode = currentNode.edges[branchIndex];
                        travellerBranchIndex += 1;
                    }
                    else {
                        currentNode = ProgressIndicator.getLongestBranch(currentNode);
                    }
                }
                else if (currentNode.numberOfConnections() === 0) {
                    break;
                }
                else {
                    currentNode = currentNode.edges[0];
                }
            }

            this.path = navPoints;
        }

        private static getLongestBranch<T>(node: DagNode<T>): DagNode<T>|null {
            let max = -1;
            let maxNode: DagNode<any>|null = null;

            for (let n of node.edges) {
                if (n.maxLengthToEnd > max) {
                    max = n.maxLengthToEnd;
                    maxNode = n;
                }
            }

            return maxNode;
        }
    }

    interface SubNode {
        node: DagNode<string>;
        visited: boolean;
    }

    interface NavigationNode {
        node: DagNode<string>;
        visited: boolean;
        subNodes: SubNode[];    
    }

